var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMx = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M341.334 85.33H0v341.332h512V85.33z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 85.333h170.663V426.67H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M170.663 85.333h170.663V426.67H170.663z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M208 255.996c0 26.509 21.491 48 48 48s48-21.491 48-48v-16h-96v16z",
  fill: "#6da544"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M320 223.996h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16H208c0 8.836 7.164 16 16 16 0 8.836 7.164 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.836 0 16.533-7.163 16.533-16z",
  fill: "#ff9811"
})));

export default SvgMx;